import React from "react";
import {AppApi} from "../../../../utils/AppApi";
import {useAlert} from "../../../../utils/components/providers/AlertProvider";
import {Utils} from "../../../../utils/Utils";
import EditMembershipType from "./EditMembershipType";

export interface MembershipType {
    membership_type_id: number
    type_name: string
    registration_fee: number
}

const initialMembership: MembershipType = {
    membership_type_id: 0, registration_fee: 0, type_name: ""
}

export default function MembershipTypes() {
    const {showMessage} = useAlert()
    const [memberships, setMemberships] = React.useState<MembershipType[]>([])
    const [editData, setEditData] = React.useState({show: false, membership: initialMembership})

    const getMembershipTypes = () => {
        Utils.toggleSpinner('show')
        AppApi.getMembershipTypes()
            .then(res => {
                Utils.toggleSpinner('hide')
                if (res.data.success) {
                    setMemberships(res.data['memberships'])
                }
            })
            .catch(() => {
                Utils.toggleSpinner('hide')
                showMessage({message: 'Error while loading membership types', type: 'error'})
            })
    }

    React.useEffect(() => {
        getMembershipTypes()
    }, [])

    return (
        <>
            <div className={'action_container'}>
                <span className={'action_btn'} onClick={() => setEditData({membership: initialMembership, show: true})}>Add New</span>
                <span className={'action_btn'} onClick={getMembershipTypes}>Load List</span>
            </div>

            <div className="table-responsive">
                <table id="example" className="table table-striped w-100">
                    <thead>
                        <tr>
                            <th>Type Name</th>
                            <th>Registration Fee</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            memberships?.map((membership: MembershipType) =>
                                <tr key={membership.membership_type_id}>
                                    <td>{membership.type_name}</td>
                                    <td>{membership.registration_fee.toLocaleString()}</td>
                                    <td>
                                        <span className={'action_btn'}
                                              onClick={() => setEditData({show: true, membership: membership})}>
                                            Edit
                                        </span>
                                        <span className={'action_btn'}>Delete</span>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>

            <EditMembershipType
                show={editData.show} membershipType={editData.membership}
                close={(aMember) => {
                    if (aMember !== undefined) {
                        if (editData.membership.membership_type_id === 0) {
                            setMemberships([aMember, ...memberships])
                        } else {
                            setMemberships(memberships.map(bMember =>
                                bMember.membership_type_id === aMember.membership_type_id ? aMember : bMember))
                        }
                    }
                    setEditData({membership: initialMembership, show: false})
                }}/>
        </>
    )
}